<template>
  <div id="EditPermRoleDialog">
    <el-dialog title="" width="540px" :visible.sync="isVisibleTemp">
      <div class="table-box">
        <div class="eb-table">
          <el-table ref="multipleTable" :data="permRoleList" :stripe="true" style="width: 100%" @select="handleRowSelect">
            <el-table-column type="selection" width="70">
            </el-table-column>
            <el-table-column prop="roleId" label="角色ID" width="110"></el-table-column>
            <el-table-column prop="roleName" label="角色名称"></el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="isVisibleTemp = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import $ from 'jquery';
import { map, includes } from 'lodash';
import { addRolePerm, cancelRolePerm } from '@/services/system-service';
export default {
  props: {
    permRoleList: {
      type: Array
    },
    permId: {
      type: Number
    },
    isVisible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      multipleSelection: []
    };
  },
  created() {},
  watch: {
    permRoleList(newVal) {
      this.$nextTick(() => {
        this.permRoleList.forEach(row => {
          if (row.permId) {
            this.$refs.multipleTable.toggleRowSelection(row, true);
          } else {
            this.$refs.multipleTable.toggleRowSelection(row, false);
          }
        });
        let checkboxTh = $(this.$refs.multipleTable.$el)
          .children('.el-table__header-wrapper')
          .find('.el-table-column--selection');

        checkboxTh.find('.el-checkbox').css('display', 'none');
        let checkboxDiv = checkboxTh.children('div');
        if (checkboxDiv.text().indexOf('选择') === -1) {
          checkboxTh.children('div').append('选择');
        }
        // console.info($(this.$refs.multipleTable.$el).children('.el-table__header-wrapper').find('.el-table-column--selection'));
      });
    }
  },
  computed: {
    isVisibleTemp: {
      get: function() {
        return this.isVisible;
      },
      set: function(val) {
        this.$emit('update:isVisible', val);
      }
    }
  },
  methods: {
    async handleRowSelect(selection, row) {
      let currSelectedArr = map(selection, n => {
        return n.roleId;
      });
      let checked = includes(currSelectedArr, row.roleId);
      let params = {
        permId: this.permId,
        roleId: row.roleId
      };
      this.$root.layout.isLoading = true;
      if (checked) {
        // 添加
        try {
          let { data } = await addRolePerm(params);
          if (data.returnCode === '01') {
            this.$root.layout.isLoading = false;
          }
        } catch (error) {
          this.$message.error('添加授权失败');
        }
      } else {
        // 删除
        try {
          let { data } = await cancelRolePerm(params);
          if (data.returnCode === '01') {
            this.$root.layout.isLoading = false;
          }
        } catch (error) {
          this.$message.error('删除授权失败');
        }
      }
    }
  }
};
</script>
<style lang="less">
#EditPermRoleDialog {
  .dialog-footer {
    text-align: center;
  }
}
</style>
